module.exports = __webpack_public_path__ + "static/4-a51a69b1370d1a9359fd5ce8aaf31da5.jpg";